// DS1.7.3
import React from 'react';
import classnames from 'classnames';
import s from './MediaIndicator.scss';
function formatDuration(duration = 0) {
    if (!duration) {
        return null;
    }
    const seconds = duration % 60;
    const minutes = (duration - seconds) / 60;
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
}
const MediaIndicator = ({ type , duration , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, type === 'gif' && 'GIF', type === 'video' && formatDuration(duration));
MediaIndicator.displayName = 'MediaIndicator';
export default MediaIndicator;
